import { useMemo, useState } from 'react';

import {
  CURRENCY_UNITS,
  CURRENCY_VARIANTS,
  MAX_PERCENT_VALUE,
  PERCENT_AMOUNT_DIVISOR,
  STYLE_VARIANTS
} from '../lib/constants';

const useUnit = ({ currentUnit, value = 0, onUnitChange, style }) => {
  const [inputUnit, setInputUnit] = useState(currentUnit?.value || STYLE_VARIANTS[style]);

  const currentStyle = useMemo(() => {
    if (!inputUnit || inputUnit === 'decimal') return style;
    return CURRENCY_UNITS.includes(inputUnit)
      ? CURRENCY_VARIANTS.currency
      : CURRENCY_VARIANTS.percent;
  }, [style, inputUnit]);

  const isPercent = currentStyle === CURRENCY_VARIANTS.percent;

  const handleUnitChange = (unit) => {
    setInputUnit(unit);

    const isNewUnitPercent = !CURRENCY_UNITS.includes(unit);
    const isOldUnitPercent = !CURRENCY_UNITS.includes(inputUnit);

    if (isNewUnitPercent !== isOldUnitPercent) {
      if (isNewUnitPercent) {
        const percentageValue = (value / MAX_PERCENT_VALUE) * PERCENT_AMOUNT_DIVISOR;
        onUnitChange(unit, percentageValue);
      } else {
        onUnitChange(unit, value);
      }
      return;
    }

    onUnitChange(unit, value);
  };

  return { inputUnit, handleUnitChange, currentStyle, isPercent };
};

export default useUnit;
